export enum StudentIdentificationMethod {
  BOC = 'BOC',
  SID = 'SID',
  Identikey = 'Identikey',
  IdentikeyAndSID = 'IdentikeyAndSID'
}

export interface StudentIdentificationModel {
  identifier: string
  kioskState: StudentIdentificationMethod
}
